<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="tableColumns"
  [ppOption]="value"
  ppClass="advancedFilter__option--select"
  [ppShowFieldTooltips]="true"
  [ppNoSearchBar]="false"
  (ppOptionChange)="changeFieldValue($event)"
></pp-advanced-filter-option-select>
